/*Copyright (c) 2023. Honeywell International, Inc. All rights reserved.
This file contains trade secrets of Honeywell International, Inc. 
No part may be reproduced or transmitted in any form by any means or for any purpose without the express written permission of Honeywell. */
/**
 *
 * @returns access token
 */
export const getAccessToken = () => {
  let oidcDefault: any = sessionStorage.getItem("oidc.default");
  return JSON.parse(oidcDefault)?.tokens?.accessToken;
};
